import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {choose} from 'lit/directives/choose.js';
import {when} from 'lit/directives/when.js';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../store';
import {conditional} from '../../util/conditional';
import {getProductData} from '../../util/getProductData';
import {pimText, pimTextDebug} from '../../util/values';
import {selectIsSingle, selectProductModelId, selectSpcConfiguration} from '../../selectors';
import {luminaryOptions} from '../../lightProfile/lightProfileSectionConfig';

@customElement('shared-technical-data-page')
export class SharedTechnicalDataPage extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				margin: 0;
				max-height: 87%;
			}

			.pageContainer {
				display: flex;
				justify-content: space-between;
				width: 100%;
				gap: 1cqw;
				padding-top: 2cqw;
				overflow-y: hidden;
			}

			.drawing {
				width: 30%
			}

			.dataList {
				width: 70%;
			}

			.imageContainer {
				text-align: center;
				width: 80%;
				margin-left: 0;
				margin-right: auto;
			}

			.imageContainer:has(svg-aeto) {
				width: auto;
				height: 50%;
			}
			.imageContainer:has(svg-productimage) {
				width: auto;
				height: 50%;
			}

			img {
				max-width: 100%;
			}

			.productImage {
				max-width: 100%;
			}
		`]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.productData = state.productData;
		this.status = state.status;
		this.lang = state.status.lang;
		this.lightProfile = state.lightProfile.data;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}

	getValueFromProductData(featureId, featureValueId) {
		const pd = getProductData(featureId, this.productData);
		return pd?.values?.find(val => val.valueId === featureValueId);
	}

	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.spcConfiguration, this.state.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.spcConfiguration, this.state.productData.translations, value, prefix, suffix);
	}

	c(id) {
		return conditional(this.spcConfiguration, this.conditionalVariantValues, id);
	}

	render() {
		const s = this.state;
		const lmo = luminaryOptions.find(luminaryOption => luminaryOption.id === this.lightProfile.project.luminary);
		let image = '';
		if (lmo && lmo.hasOwnProperty('imageModelSpecific')) {
			image = lmo.imageModelSpecific[selectProductModelId(s)].imageWhite;
		} else {
			image = lmo ? lmo.imageWhite : '';
		}
		return html`
			<div class="pageContainer">

				<div class="drawing">
					<div class="imageContainer">
						${choose(
							this.status.family, [
								[
									'LightProfile',
									() => html`<img src="${image}"/>`
								],
								[
									'TheLine',
									() => html`
										${when(selectIsSingle(s),
											() => html`
												<svg-optics-specsheet></svg-optics-specsheet>`,
											() => html`
												<svg-productimage></svg-productimage>`)}`
								], [
									'Aeto',
									() => html`
										<svg-aeto></svg-aeto>`
								]
							],
							() => html`
								${when(this.c('REDTAB.RETURN_LU_Image') && this.c('REDTAB.RETURN_LU_Image') !== '', () => html`
									<img class="productImage" alt="product image" src="${this.c('REDTAB.RETURN_LU_Image')}"/>
								`)}
							`)
						}
					</div>
				</div>

				<div class="dataList">
					${choose(this.status.family, [
							['Aeto', () => html`
								<solar-technical-data></solar-technical-data>`],
							['TheLine', () => html`
								<line-technical-data></line-technical-data>`]
						],
						() => html`
							<shared-technical-data></shared-technical-data>`)
					}
				</div>
			</div>
		`;
	}
}
